export default __webpack_public_path__ + "static/brain-f5a7dbd356c146fefc0ad43355c41acd.png";